module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_3009.5a70d250.png";